module.exports = __webpack_public_path__ + "static/media/attachment.b5003d03.png";